export default {
  type: 'TL',
};
